import { render, staticRenderFns } from "./verifyLike.vue?vue&type=template&id=49920e18&scoped=true"
import script from "./verifyLike.vue?vue&type=script&lang=js"
export * from "./verifyLike.vue?vue&type=script&lang=js"
import style0 from "./verifyLike.vue?vue&type=style&index=0&id=49920e18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49920e18",
  null
  
)

export default component.exports